'use strict';

angular.module('systemOwnerControllers')

.controller('SelectNewPrimarySystemOwnerController', ['$scope', 'searchService', function ($scope, searchService) {

    $scope.ctxSelectNewBackup = {};

    $scope.actualBackupOwners = _.filter($scope.actualSystemOwners, { IsPrimary: false });

    $scope.searchEmployees = function () {
        var searchTerm = $scope.ctxSelectNewPrimary.searchTerm;
        if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
            $scope.primaryEmployees = $scope.actualBackupOwners;
            return;
        }
        searchService.searchActiveEmployees(searchTerm)
        .then(function (foundEmployees) {
            $scope.primaryEmployees = _.filter(foundEmployees, function (foundEmployee) {
                return _.findIndex($scope.actualSystemOwners, { EmployeeID: foundEmployee.EmployeeID }) === -1;
            });
        });
    }
}]);